/** Web push via Firebase Cloud Messaging: asked for right after a user follows
 *  a feeder or a cat. Needs VITE_FIREBASE_* incl. MESSAGING_SENDER_ID and VAPID_KEY. */
import { api } from './api/client.js'
import { firebaseConfig, firebaseEnabled, getFirebaseAuth } from './firebase.js'

const VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY

export const pushSupported = () =>
  firebaseEnabled &&
  Boolean(VAPID_KEY && firebaseConfig.messagingSenderId) &&
  'Notification' in window &&
  'serviceWorker' in navigator

export async function enablePush() {
  if (!pushSupported() || Notification.permission === 'denied') return false
  if ((await Notification.requestPermission()) !== 'granted') return false
  const params = new URLSearchParams(firebaseConfig).toString()
  const registration = await navigator.serviceWorker.register(`/firebase-messaging-sw.js?${params}`)
  const [{ app }, { getMessaging, getToken }] = await Promise.all([getFirebaseAuth(), import('firebase/messaging')])
  const token = await getToken(getMessaging(app), { vapidKey: VAPID_KEY, serviceWorkerRegistration: registration })
  if (token) await api.registerPush(token)
  return Boolean(token)
}
